module.exports = __webpack_public_path__ + "static/media/pokelogo.9dceab91.webp";